'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUIApplicationLogo = function AUIApplicationLogo(_ref) {
    var logo = _ref.logo,
        text = _ref.text,
        children = _ref.children,
        headerLink = _ref.headerLink;

    var logoClass = void 0;
    if (logo) {
        logoClass = 'aui-header-logo-' + logo;
    }
    var classes = (0, _classnames2.default)('aui-header-logo', {
        'aui-header-logo-textonly': text
    }, logoClass);

    return _react2.default.createElement(
        'h1',
        { className: classes, id: 'logo' },
        _react2.default.createElement(
            'a',
            { href: headerLink },
            _react2.default.createElement(
                'span',
                { className: 'aui-header-logo-device' },
                children || text
            )
        )
    );
};

AUIApplicationLogo.displayName = 'AUIApplicationLogo';
AUIApplicationLogo.defaultProps = {
    headerLink: '/'
};

AUIApplicationLogo.propTypes = {
    children: _propTypes2.default.node,
    headerLink: _propTypes2.default.string,
    logo: _propTypes2.default.oneOf(['aui', 'bamboo', 'bitbucket', 'confluence', 'crowd', 'fecru', 'hipchat', 'jira', 'stash']).isRequired,
    text: _propTypes2.default.string
};

exports.default = AUIApplicationLogo;
//# sourceMappingURL=AUIApplicationLogo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIApplicationLogo.js
// module id = 170
// module chunks = 0